export class SlashTree {
	public rootNode: SlashTreeNode;

	constructor(data: any[] = [], field: string|((item:any)=>string) = "", separator: string = "/") {
		this.rootNode = this.newNode();
		this.separator = separator;
		for (const item of data) {
			const path = typeof field === "string"
				? item[field]
				: field(item);

			this.addItem(path, item);
		}
	}

	public separator: string; // = '/';

	public trimPathItem: boolean = true;

	public caseInsensitivePathItem: boolean = true;

	protected nodeByPath(path: string): SlashTreeNode
	{
		const pathItems = path.split(this.separator);
		let n = this.rootNode;
		for(let pathItem of pathItems) {
			if (this.trimPathItem) pathItem = pathItem.trim();
			const pathItemCS = pathItem;
			if (this.caseInsensitivePathItem) pathItem = pathItem.toLowerCase();
			let nn = n.items.find(n => n.key == pathItem);
			if (!nn) {
				nn = this.newNode(n);
				nn.name = pathItemCS;
				nn.key = pathItem;
				n.items.push(nn);
			}
			n = nn;
		}

		return n;
	}

	private newNode(parent: SlashTreeNode|null = null): SlashTreeNode {
		return {
			name: "",
			key: "",
			items: [],
			data: {},
			parent: parent
		};
	}

	public addItem(path: string, data: any)
	{
		this.nodeByPath(path).data = data;
	}

	public static parse(data: any[] = [], field: string|((item:any)=>string) = "", separator: string = "/") {
		return new SlashTree(data, field, separator).rootNode;
	}

	static getItemsRecursive(item: SlashTreeNode): SlashTreeNode[] {
		const res: SlashTreeNode[] = [];
		const addItems = (item: SlashTreeNode) => {
			res.push(item);
			item.items.map(subItem => addItems(subItem));
		};
		addItems(item);

		return res; // [ item, ...item.items.map(it => this.getItemsRecursive(it))] as SlashTreeNode[]; // item.items.reduce((acc, curr) => [...acc, ...curr.items], [] as SlashTreeNode[]);
	}
}

export type SlashTreeNode = {
	data: any,
	name: null|string,
	key: null|string,
	items: SlashTreeNode[],
	parent: SlashTreeNode|null
}